export const replaceBulk = (s, findArray, replaceArray) => {
	let index;
	const regex = [];
	const map = {};
	for (index = 0; index < findArray.length; index++) {
		regex.push(findArray[index].replace(/([#$()*+,.?[\\\]^{|}-])/g, '\\$1'));
		map[findArray[index]] = replaceArray[index];
	}
	return s.replace(new RegExp(regex.join('|'), 'g'), matched => map[matched]);
};
